<script lang="ts">
	import XIcon from '@lib/images/icons/social-media/x.svg';
	import facebookIcon from '@lib/images/icons/social-media/facebook.svg';
	import whatsAppIcon from '@lib/images/icons/social-media/whatsapp.svg';
	import lineIcon from '@lib/images/icons/social-media/line.svg';
	import threeDotsIcon from '@lib/images/icons/three-dots.svg';
	import copyIcon from '@lib/images/icons/copy.svg';
	import { PUBLIC_SITE_NAME } from '$env/static/public';
	import { toast } from 'svelte-sonner';
	import CenterNotify from '@components/global/micro/CenterNotify.svelte';
	import { truncate } from 'lodash-es';

	export let title: string,
		shareUrl: string,
		textTemplate = `Yuk!, langganan buku online ${title} dan dapatkan berbagai diskon eksklusif di ${PUBLIC_SITE_NAME} dengan klik link berikut ini: ${shareUrl}`;

	$: sharePlatforms = [
		{
			label: 'WhatsApp',
			url: `https://api.whatsapp.com/send?text=${encodeURIComponent(textTemplate)}`,
			icon: whatsAppIcon
		},
		{
			label: 'X',
			url: `https://x.com/intent/tweet?text=${encodeURIComponent(textTemplate)}`,
			icon: XIcon
		},
		{
			label: 'Line',
			url: `https://lineit.line.me/share/ui?url=${encodeURIComponent(textTemplate)}`,
			icon: lineIcon
		},
		{
			label: 'Facebook',
			url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(textTemplate)}`,
			icon: facebookIcon
		},
		{
			label: 'Salin Link',
			callback: copyShareUrl,
			icon: copyIcon
		},
		{
			label: 'Lainnya',
			callback: triggerOthersShare,
			icon: threeDotsIcon
		}
	];

	let isSuccessCopy = false,
		successCopyMessage = 'Link berhasil disalin!';

	function copyShareUrl() {
		try {
			navigator.clipboard.writeText(shareUrl);
			isSuccessCopy = true;
		} catch (error) {
			console.error(error);
			toast.error('Gagal menyalin link');
		}
	}

	function triggerOthersShare() {
		// Check if Share API is supported
		if (!navigator.share) {
			toast.error('Oops, browsermu tidak mendukung fitur share lainnya');
			return;
		}

		navigator.share({
			url: shareUrl,
			title: `Yuk!, langganan buku online ${title} dan dapatkan berbagai diskon eksklusif di ${PUBLIC_SITE_NAME}`,
			text: textTemplate
		});
	}
</script>

{#if isSuccessCopy}
	<CenterNotify duration={3500} bind:isShow={isSuccessCopy} message={successCopyMessage} />
{/if}

<div class="flex items-center gap-3">
	<slot name="image" />
	<div class="flex-1">
		<p class="line-clamp-2 font-medium">
			{title}
		</p>
		<p class="mt-2 text-xs text-gray-400">{truncate(shareUrl, { length: 40 })}</p>
	</div>
</div>
<div class="mt-4 border-t py-4">
	<div class="mx-auto flex max-w-xs flex-wrap items-start justify-center gap-4">
		{#each sharePlatforms as platform}
			{#if platform.callback}
				<button
					on:click={platform.callback}
					type="button"
					class="platform-btn text-xs text-gray-400"
				>
					<div class="icon-wrapper">
						<img
							loading="lazy"
							class="aspect-square size-6"
							src={platform.icon}
							alt="Tautan buku ke {platform.label}"
						/>
					</div>
					{platform.label}
				</button>
			{:else}
				<a href={platform.url} target="_blank" rel="noreferrer noopener" class="platform-btn">
					<div class="icon-wrapper">
						<img
							class="aspect-square size-8"
							src={platform.icon}
							alt="Tautan buku ke {platform.label}"
						/>
					</div>
					<p class="text-xs text-gray-400">{platform.label}</p>
				</a>
			{/if}
		{/each}
	</div>
</div>

<style lang="postcss">
	.platform-btn {
		@apply flex flex-col items-center justify-center gap-2 text-center;

		& > .icon-wrapper {
			@apply grid size-14 place-items-center rounded-full border;
		}
	}
</style>
